export default __webpack_public_path__ + "static/media/play_store.0b779f08.png";